import * as angular from "angular";

export class FieldService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/field";
        this.v2Root = "/v2/field";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot, { params: data });
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.id, data);
    }

    updateMultiple(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update_multiple", data);
    }

    updateOrder(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/updateOrder", data);
    }

    getAttachment(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/get_attachment/" + data.id, {
            params: data,
        });
    }

    getMultipleAttachments(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/get_multiple_attachments", {
            params: data,
        });
    }

    getFieldValues(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/values/" + data.id);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }
}
angular.module("vcServices").service("FieldService", FieldService);
